var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "button",
              {
                staticClass: "btn-info",
                attrs: { type: "button" },
                on: { click: _vm.consultar }
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _c("span", [_vm._v("Consultar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-secondary",
                attrs: { type: "button" },
                on: { click: _vm.mostrarHistoricos }
              },
              [
                _c("i", { staticClass: "fa fa-history" }),
                _c("span", [_vm._v("Historial")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-success",
                attrs: { type: "button" },
                on: { click: _vm.exportarExcel }
              },
              [
                _c("i", { staticClass: "fa fa-file-excel-o" }),
                _c("span", [_vm._v("Excel")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c("div", { staticClass: "form-field" }, [
                _c(
                  "div",
                  { staticClass: "datepicker-field" },
                  [
                    _c("VueCtkDateTimePicker", {
                      attrs: {
                        id: "desde",
                        locale: "es",
                        "only-date": "",
                        "no-label": "",
                        "button-now-translation": "Ahora",
                        format: "YYYY-MM-DD",
                        formatted: "YYYY-MM-DD",
                        label: "Seleccione fecha..."
                      },
                      model: {
                        value: _vm.form.fecha,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "fecha", $$v)
                        },
                        expression: "form.fecha"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("Fecha")])
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c(
                "div",
                { staticClass: "form-field select2 select2-field--stretch" },
                [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          filterable: false,
                          label: "descripcion",
                          placeholder: "Seleccione...",
                          options: _vm.bodegas,
                          id: "bodegas"
                        },
                        on: { input: _vm.inputBodega },
                        model: {
                          value: _vm.selectedBodega,
                          callback: function($$v) {
                            _vm.selectedBodega = $$v
                          },
                          expression: "selectedBodega"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "bodegas" } }, [
                        _vm._v("Sucursal")
                      ])
                    ],
                    1
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c("div", { staticClass: "form-field select2" }, [
                _c(
                  "div",
                  { staticClass: "select2-field" },
                  [
                    _c("v-select", {
                      attrs: {
                        placeholder: "Seleccione...",
                        id: "recaudador_id",
                        options: _vm.recaudadores,
                        label: "nombre"
                      },
                      on: {
                        search: _vm.searchRecaudadores,
                        input: _vm.inputRecaudador
                      },
                      model: {
                        value: _vm.selectedRecaudador,
                        callback: function($$v) {
                          _vm.selectedRecaudador = $$v
                        },
                        expression: "selectedRecaudador"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "recaudador_id" } }, [
                      _vm._v("Recaudador")
                    ])
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c("div", { staticClass: "form-field select2" }, [
                _c(
                  "div",
                  { staticClass: "select2-field" },
                  [
                    _c("v-select", {
                      attrs: {
                        placeholder: "Seleccione...",
                        id: "ruta_id",
                        options: _vm.rutas,
                        label: "descripcion"
                      },
                      on: { search: _vm.onSearchRuta, input: _vm.inputRuta },
                      model: {
                        value: _vm.selectedRuta,
                        callback: function($$v) {
                          _vm.selectedRuta = $$v
                        },
                        expression: "selectedRuta"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "ruta_id" } }, [_vm._v("Ruta")])
                  ],
                  1
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12" }, [
              _c(
                "div",
                {
                  staticClass: "table-responsive",
                  staticStyle: { "max-height": "300px" }
                },
                [
                  _c("table", { staticClass: "custom-table" }, [
                    _vm._m(3),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        _c(
                          "tr",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.cobranzas.length === 0,
                                expression: "cobranzas.length === 0"
                              }
                            ]
                          },
                          [_vm._m(4)]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.cobranzas, function(cobranza, key) {
                          return _c("tr", { key: key }, [
                            _c("td", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(key + 1) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(cobranza.numero_documento) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(cobranza.fecha_ultimo_abono) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(cobranza.nombre_cliente) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(cobranza.telefonos) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.moneyFormat(cobranza.valor_estimado)
                                  ) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.moneyFormat(cobranza.saldo_actual)
                                  ) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.moneyFormat(cobranza.valor_abono)
                                  ) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.moneyFormat(cobranza.saldo)) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(cobranza.premio) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(cobranza.devolucion) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(cobranza.cambio_in) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(cobranza.cambio_sa) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(cobranza.numero_comp_pago) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(cobranza.observacion) +
                                  "\n                  "
                              )
                            ])
                          ])
                        })
                      ],
                      2
                    )
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12" }, [
              _c("h5", [_vm._v("Cuadre de mercadería")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-responsive",
                  staticStyle: { "max-height": "300px" }
                },
                [
                  _c("table", { staticClass: "custom-table" }, [
                    _vm._m(5),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.cuadreMercaderia, function(cuadre, index) {
                        return _c("tr", { key: index }, [
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(cuadre.descripcion_item) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(parseInt(cuadre.cantidad_inicial)) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(parseInt(cuadre.devoluciones)) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(parseInt(cuadre.cambios_devoluciones)) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(parseInt(cuadre.total_ingresos)) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(parseInt(cuadre.cambios_aumentos)) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(parseInt(cuadre.aumentos)) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(parseInt(cuadre.premios)) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(parseInt(cuadre.total_egresos)) +
                                "\n                  "
                            )
                          ])
                        ])
                      }),
                      0
                    )
                  ])
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "historicos",
            height: "auto",
            width: "70%",
            scrollable: "",
            adaptive: "",
            resizable: "",
            reset: ""
          }
        },
        [_c("reportes-historicos-excel", { attrs: { tipoReporte: "cr" } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Informe de Recaudador")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Filtros de la consulta")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Resultados de la consulta")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("No.")]),
        _vm._v(" "),
        _c("th", [_vm._v("# Cartilla")]),
        _vm._v(" "),
        _c("th", [_vm._v("Fecha de último abono")]),
        _vm._v(" "),
        _c("th", [_vm._v("Nombre del cliente")]),
        _vm._v(" "),
        _c("th", [_vm._v("Teléfono")]),
        _vm._v(" "),
        _c("th", [_vm._v("Valor estimado a cobrar")]),
        _vm._v(" "),
        _c("th", [_vm._v("Saldo actual")]),
        _vm._v(" "),
        _c("th", [_vm._v("Abono")]),
        _vm._v(" "),
        _c("th", [_vm._v("Saldo")]),
        _vm._v(" "),
        _c("th", [_vm._v("Premio")]),
        _vm._v(" "),
        _c("th", [_vm._v("Devolución")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cambio(+)")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cambio(-)")]),
        _vm._v(" "),
        _c("th", [_vm._v("# Comprobante de pago")]),
        _vm._v(" "),
        _c("th", [_vm._v("Observación")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "14" } }, [
      _c("strong", [_vm._v("No se ha encontrado datos.")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Mercadería")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cantidad inicial")]),
        _vm._v(" "),
        _c("th", [_vm._v("Ingreso (+) Devolución")]),
        _vm._v(" "),
        _c("th", [_vm._v("Ingreso (+) Cambios")]),
        _vm._v(" "),
        _c("th", [_vm._v("Ingreso Total")]),
        _vm._v(" "),
        _c("th", [_vm._v("Salida (-) Cambios")]),
        _vm._v(" "),
        _c("th", [_vm._v("Salida (-) Ventas")]),
        _vm._v(" "),
        _c("th", [_vm._v("Salida (-) Premios")]),
        _vm._v(" "),
        _c("th", [_vm._v("Salida Total")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e96c24ea", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e96c24ea","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/ReporteCobranza.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-e96c24ea","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/ReporteCobranza.vue
// module chunks = 0